import { scenarioApi } from "api/scenario.api"
import { useState } from "react"
import { Scenario } from "types/scenario"
import { QueryParam } from "types/query"

export interface ScenarioQuery extends QueryParam {

}

interface UseScenarioProps {
  initQuery: ScenarioQuery;
}

export const useScenario = ({ initQuery }: UseScenarioProps) => {
  const [data, setData] = useState<Scenario[]>([])
  const [total, setTotal] = useState(0)
  const [query, setQuery] = useState<ScenarioQuery>(initQuery);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await scenarioApi.findAll(query)

      setData(data.scenarios)
      setTotal(data.total)
      return data.scenarios as Scenario[]
    } finally {
      setLoading(false);
    }
  }

  return { scenarios: data, totalScenario: total, fetchScenario: fetchData, loadingScenario: loading, setQueryScenario: setQuery, queryScenario: query }
}